import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ordersForUserQuery } from '../../graphql/queries';
import { centsToPrice } from '@/utils/formatter';
import i18n from '@/utils/i18n';
import {
  EditItem,
  EditSection,
  LoadingContainer,
  ResponsiveTable,
} from '../../components/Layout';
import {
  CheckBoxContainer,
  CheckBoxLabel,
} from '../../pages/AdminStoreOrders/styled';
import { Checkbox } from 'primereact/checkbox';

type UserOrdersTabProps = {
  externalPickpackId: string | null;
};

export const UserOrdersTab: React.FC<UserOrdersTabProps> = ({
  externalPickpackId,
}) => {
  const [showAll, setShowAll] = useState(false);
  const timespanFrom = showAll
    ? moment('2016-01-01')
    : moment().add(-30, 'days');
  const { data = { orders: [] }, loading } = useQuery(ordersForUserQuery, {
    variables: {
      user_id: externalPickpackId,
      timespan_from: timespanFrom.format('YYYY-MM-DD'),
    },
  });
  const { orders } = data;

  if (loading) {
    return <LoadingContainer />;
  }

  return (
    <EditSection title={i18n.t('Users:pastOrders')}>
      {orders && (
        <EditItem title={i18n.t('Users:last30Days')}>
          {orders.length === 0 && (
            <p className="mt-4"> -- keine Bestellungen gefunden --</p>
          )}
          {orders.length > 0 && (
            <>
              <CheckBoxContainer
                className="mt-4"
                onClick={() => setShowAll(!showAll)}
              >
                <Checkbox checked={showAll} />
                <CheckBoxLabel>{' alle anzeigen'}</CheckBoxLabel>
              </CheckBoxContainer>
              <ResponsiveTable className="mt-4">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Status</th>
                    <th>Total</th>
                    <th>Pickup time</th>
                    <th>Store</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(
                    (order: {
                      pickup_time: string;
                      store: {
                        brand?: any;
                        name?: string;
                        external_vytal_id?: string;
                      };
                      id: string;
                      code_text: string;
                      status: string;
                      total: number;
                      currency: any;
                    }) => {
                      // @ts-ignore
                      const pickupTimeFormatted = moment(
                        order.pickup_time,
                      ).format('HH:mm - DD.MM.YYYY');
                      const {
                        name: storeName,
                        external_vytal_id: vytalStoreId,
                      } = order.store || {};
                      // @ts-ignore
                      const {
                        name: merchantName,
                        external_vytal_id: vytalMerchantId,
                      } = order.store.brand || {};

                      return (
                        // @ts-ignore
                        <tr key={order.id}>
                          {/*@ts-ignore*/}
                          <td>
                            <Link to={`/pre-order/${order.id}`}>
                              {order.code_text}
                            </Link>
                          </td>
                          {/*@ts-ignore*/}
                          <td>{order.status}</td>
                          {/*@ts-ignore*/}
                          <td>{centsToPrice(order.total, order.currency)}</td>
                          <td>{pickupTimeFormatted}</td>
                          <td>
                            {vytalStoreId && vytalMerchantId ? (
                              <a
                                href={`/merchants/${vytalMerchantId}/${vytalStoreId}`}
                              >{`${merchantName}:  ${storeName}`}</a>
                            ) : (
                              <span>{`${merchantName}:  ${storeName}`}</span>
                            )}
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </ResponsiveTable>
            </>
          )}
        </EditItem>
      )}
    </EditSection>
  );
};
